export default __webpack_public_path__ + "static/article-renovation-5-projects-d7d53999e7bdc3143e7ca1793be0421b.jpg";